import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { NotificationTypes } from 'src/app/common/component/notification/notification.component';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { O2PortalHycoReportService } from 'src/app/reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-o2-portal-hyco-award-details-report',
  templateUrl: './o2-portal-hyco-award-details-report.component.html',
  styleUrls: ['./o2-portal-hyco-award-details-report.component.scss']
})
export class O2PortalHycoAwardDetailsReportComponent {

  awardDetails: any;
  isLoadPanelVisible: boolean = false;
  readonly allowedPageSizes = [50, 100, 200];
  @Input() selectedAnnouncementYear: number;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  constructor(private notificationService: NotificationService, private o2PortalHycoReportService: O2PortalHycoReportService) {
  }

  getAwardDetails(announcementYear, noOfyear) {
    this.o2PortalHycoReportService.getAwardDetails(announcementYear, noOfyear).subscribe({
      next: data => {
        this.awardDetails = data;
      },
      error: (error: any) => {
        this.notificationService.alert(NotificationTypes.Error, "Error while fetching Award Details", error);
      }
    });
  }

  resetFilters() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearSorting();
  }

  exportExcel(e) {
    this.dataGrid.instance.columnOption('siteId', 'visible', true);
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AwardDetails.xlsx');
        });
    }).then(() => {
      this.dataGrid.instance.columnOption('siteId', 'visible', false);
    });
    e.cancel = true;
  }

}
